// eslint-disable-next-line no-shadow
export enum DeclineOptions {
  One = 'one',
  All = 'all',
}
